(function () {
    'use strict';

    angular
        .module('ib-seat-map-module')
        .controller('ibFlightMapController', ibFlightMapController);

    ibFlightMapController.$inject = ['$scope', '$timeout', '$filter', '$rootScope', '$window', 'AncillariesConstants', 'AncillariesUtilsService', 'ModalServiceAncillaries', '$compile'];
    function ibFlightMapController ($scope, $timeout, $filter, $rootScope, $window, AncillariesConstants, AncillariesUtilsService, ModalServiceAncillaries, $compile) { //currentPassenger && model comes from directives input

        const vm = this;
        vm.seatInfoSelected;
        vm.isInfiniteScroll = false;
        vm.tooltipOpened = false;
        vm.isMobile = AncillariesUtilsService.isTouchDevice();
        vm.isAllowed = isAllowed;
        vm.stateSeats = stateSeats;
        vm.isEmergency = isEmergency;
        vm.tooltipHover = tooltipHover;
        vm.tooltipTouch = tooltipTouch;
        vm.change = change;
        vm.isDisabledOccupation = isDisabledOccupation;
        vm.scrollToSeat = scrollToSeat;
        vm.createFirstId = createFirstId;
        vm.isWing = isWing;
        vm.$onInit = activate;



        $scope.$on('scrollToSeat', (event, arg) => {
            scrollToSeat(vm.currentPassenger.currentSeat);
        });

        //When collapses map seats leyend, changes height container in seat maps
        $scope.$on('changeCollapse', (event) => {
            changeHeightContainer();
        });


        vm.eventTooltipOpened = $rootScope.$on('tooltipOpened', (e, data) => {
            vm.tooltipOpened = data;
        });


        function activate () {
            let isDisabled = false, i = 0;
            while (!isDisabled && i < vm.passengers.length) {
                if (vm.passengers[i].initialSeat.row !== '' || vm.passengers[i].initialSeat.column !== '') {
                    isDisabled = true;
                }
                i++;
            }

            vm.isInfiniteScroll = isDisabled;
            scrollToSeat(vm.currentPassenger.currentSeat);
        }

        /**
         * Scroll to tooltip
         */
        function scrollToTooltip () {
            const toolTip = angular.element('#toolTipTouch');
            angular.element('.modal-body').scrollToElementAnimated(toolTip, 50, 2000);
        }

        /**
         * Scroll to seat of current passenger in view
         * @param {Object} seat Seat information
         */
        function scrollToSeat (seat) {
            let auxSeatPreAssigned;
            let columnPreAssigned;
            const seatPreAssigned = seat;
            const id = '#cabins-' + seatPreAssigned.cabinIndex + '-row-' + seatPreAssigned.rowIndex + '-seat-' + seatPreAssigned.columnIndex;
            $timeout(() => {
                if (id !== null) {
                    auxSeatPreAssigned = angular.element(id);
                    if(auxSeatPreAssigned.length === 0) {
                        auxSeatPreAssigned = angular.element(createFirstId(seatPreAssigned.cabinIndex,
                            vm.seatsModel.cabins));
                    }
                    columnPreAssigned = angular.element(auxSeatPreAssigned).parent().parent();
                    angular.element('.modal-body').scrollToElementAnimated(columnPreAssigned, 50, 2000);
                }
            });
        }

        /**
         * Create first ID
         *
         */
        function createFirstId (index, cabins) {
            let founded=false, i=0,j=0,k=0,rowIndex=0,columnIndex=0, indexColumn=0;

            while(founded === false) {
                if(cabins[i].enabled) {
                    for (j=0; j<cabins[i].columns.length; j++) {
                        if(cabins[i].columns[j].name !=='') {
                            rowIndex=j;
                            j=cabins[i].columns.length;
                        }
                    }
                    for (j=0; j<cabins[i].seatMap.length; j++) {
                        indexColumn =j;
                        for (k=0; k<cabins[i].seatMap[indexColumn].rowSeats.length; k++) {
                            if(cabins[i].seatMap[indexColumn].rowSeats[k].column !==' ') {
                                columnIndex=k;
                                k=cabins[i].seatMap[indexColumn].rowSeats.length;
                                j=cabins[i].seatMap.length;
                            }
                        }
                    }
                    founded=true;
                }
                i++;
            }
            return '#cabins-' + index + '-row-' + rowIndex+ '-seat-' + columnIndex;
        }

        /**
         * Change Height Container triggers resize - Apply Directive ib-calculate-height-container
         */
        function changeHeightContainer () {
            $timeout(() => {
                angular.element($window).trigger('resize');
            }, 1000);
        }

        /**
         * Check if seat is allowed for current user
         * @param {Array} seatAllowed Array of passengers authorized for seat
         */
        function isAllowed (seatAllowed) {
            let isAllowed = false;
            if (seatAllowed) {
                isAllowed = seatAllowed.indexOf('' + vm.currentPassenger.id) !== -1;
            }
            return isAllowed;
        }

        /**
         * Return state of seat
         * @param {Object} seat Seat information
         * @param {String} rowFeatures Features
         * @param {String} seatIndex Index of seat
         * @param {String} rowSeats  Row of seat
         */
        function stateSeats (seat, rowFeatures, seatIndex, rowSeats) {
            let state;
            switch (seat.type) {
                    case AncillariesConstants.SeatTypes.seat: state = generateSeatClass(seat); break;
                    case AncillariesConstants.SeatTypes.gap: rowFeatures.indexOf(AncillariesConstants.SeatFeatures.emergencyExit) !== -1
                    && (seatIndex === 0 || seatIndex === rowSeats.length - 1) ? state = 'ib-map__column ib-map__column--gap--emergency'
                        : state = 'ib-map__column ib-map__column--gap  ib-map__column--unfocused'; break;
            }
            return state;
        }


        /**
         * Return class of seat
         * @param {*} seat
         */
        function generateSeatClass (seat) {
            let state;
            switch (seat.occupation) {
                    case AncillariesConstants.SEAT_OCCUPATIONS.free: state = generateFreeSeatClass(seat); break;
                    case AncillariesConstants.SEAT_OCCUPATIONS.selection: state = 'ib-map__column ib-map__column--selection'; break;
                    case AncillariesConstants.SEAT_OCCUPATIONS.blocked: state = 'ib-map__column ib-map__column--occupied'; break;
                    case AncillariesConstants.SEAT_OCCUPATIONS.occupied: state = 'ib-map__column ib-map__column--occupied'; break;
                    case AncillariesConstants.SEAT_OCCUPATIONS.occupiedOtherUser: state = 'ib-map__column ib-map__column--selected-other-passenger'; break;
                    default: state = 'ib-map__column ib-map__column--free'; break;
            }
            return state;
        }



        function generateFreeSeatClass (seat) {
            let state;
            if (vm.isAllowed(seat.passengersAllowed)) {
                state = 'ib-map__column ib-map__column--free';
                if (seat.features.indexOf(AncillariesConstants.SeatFeatures.emergencyExit) !== -1) {
                    state = 'ib-map__column ib-map__column--emergency';
                } if (seat.features.indexOf(AncillariesConstants.SeatFeatures.emergencyExit) === -1 && seat.features.indexOf(AncillariesConstants.SeatFeatures.extraSize) !== -1) {
                    state = 'ib-map__column ib-map__column--comfort ';
                } if (seat.features.indexOf(AncillariesConstants.SeatFeatures.infant) !== -1) {
                    state = 'ib-map__column ib-map__column--infant';
                } if (seat.features.indexOf(AncillariesConstants.SeatFeatures.promo) !== -1 && seat.features.indexOf(AncillariesConstants.SeatFeatures.emergencyExit) === -1) {
                    state = 'ib-map__column ib-map__column--promo';
                } if (seat.features.indexOf(AncillariesConstants.SeatFeatures.promo) !== -1 && seat.features.indexOf(AncillariesConstants.SeatFeatures.infant) !== -1) {
                    state = 'ib-map__column ib-map__column--infant';
                } if (seat.features.indexOf(AncillariesConstants.SeatFeatures.upfront) !== -1) {
                    state = 'ib-map__column ib-map__column--upfront';
                } if (seat.features.indexOf(AncillariesConstants.SeatFeatures.mobility) !== -1) {
                    state = 'ib-map__column ib-map__column--handicap';
                }
            } else {
                state = 'ib-map__column ib-map__column--occupied';
            }
            return state;
        }



        /**
         * Check if seat is emergency
         * @param {Array} rowFeatures Features of seat
         */
        function isEmergency (rowFeatures) {
            return rowFeatures.indexOf(AncillariesConstants.SeatFeatures.emergencyExit) !== -1;
        }

        /**
         * Check if seat is wing
         * @param {Array} rowFeatures Features of seat
         */
        function isWing (rowFeatures) {
            return rowFeatures.indexOf(AncillariesConstants.SeatFeatures.wing) !== -1;
        }

        /**
         * Change seat of passenger
         * @param {*} seat
         * @param {*} cabinIndex
         * @param {*} rowIndex
         * @param {*} columnIndex
         */
        function change (seat, cabinIndex, rowIndex, columnIndex) {

            let currentCabin, currentRow, currentColumn;
            if (seat.occupation === AncillariesConstants.SEAT_OCCUPATIONS.selection) {
                const modalMessage = getModalMessage(seat.modalMessages);
                if (modalMessage !== null) {
                    const modalType = getModalType(modalMessage.type);
                    ModalServiceAncillaries.openFeatureModal(modalType.templateUrl, modalType.blocked, modalMessage.message, modalType.class).result.then(accept, () => {
                        vm.tooltipOpened = false;
                        currentCabin = vm.currentPassenger.currentSeat.cabinIndex;
                        currentRow = vm.currentPassenger.currentSeat.rowIndex;
                        currentColumn = vm.currentPassenger.currentSeat.columnIndex;
                        vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].occupation = AncillariesConstants.SEAT_OCCUPATIONS.free;
                        vm.seatsModel.cabins[currentCabin].seatMap[currentRow].rowSeats[currentColumn].occupation = AncillariesConstants.SEAT_OCCUPATIONS.selection;
                    });
                } else {
                    if (!vm.isMobile) {
                        changeSeat(cabinIndex, rowIndex, columnIndex);
                    }
                }
            } else {
                const $tooltip = angular.element('.ib-map-tooltip');
                $tooltip.css('display', 'none');
                vm.tooltipOpened = false;
            }

            function accept () {
                vm.tooltipOpened = false;
                changeSeat(cabinIndex, rowIndex, columnIndex);

            }

        }

        /**
         * Change seat of user
         * @param {Integer} cabinIndex
         * @param {Integer} rowIndex
         * @param {Integer} columnIndex
         */
        function changeSeat (cabinIndex, rowIndex, columnIndex) {

            const currentCabin = vm.currentPassenger.currentSeat.cabinIndex;
            const currentRow = vm.currentPassenger.currentSeat.rowIndex;
            const currentColumn = vm.currentPassenger.currentSeat.columnIndex;
            if (currentCabin !== cabinIndex || currentRow !== rowIndex || currentColumn !== columnIndex) {
                vm.seatsModel.cabins[currentCabin].seatMap[currentRow].rowSeats[currentColumn].occupation = AncillariesConstants.SEAT_OCCUPATIONS.free;
            }
            vm.currentPassenger.currentSeat.cabinIndex = cabinIndex;
            vm.currentPassenger.currentSeat.rowIndex = rowIndex;
            vm.currentPassenger.currentSeat.columnIndex = columnIndex;
            vm.currentPassenger.currentSeat.row = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].row;
            vm.currentPassenger.currentSeat.column = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].column;
            vm.currentPassenger.currentSeat.originalType = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].originalType;
            vm.currentPassenger.currentSeat.seatType = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].seatType;
            vm.currentPassenger.currentSeat.seatTypeDescription = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].seatTypeDescription;
            vm.currentPassenger.currentSeat.seatTypeMessasge = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].seatTypeMessasge;
            vm.currentPassenger.seatPrice = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].passengersPrice[vm.currentPassenger.id];
            $scope.$emit('seatChange', {
                id: vm.currentPassenger.id,
                seat: {
                    row: vm.currentPassenger.currentSeat.row,
                    column: vm.currentPassenger.currentSeat.column
                },
                price: vm.currentPassenger.seatPrice,
                seatTypeDescription: vm.currentPassenger.currentSeat.seatTypeDescription,
                seatType: vm.currentPassenger.currentSeat.seatType,
                originalType: vm.currentPassenger.currentSeat.originalType,
                seatTypeMessasge: vm.currentPassenger.currentSeat.seatTypeMessasge
            });
        }


        /**
        * Open toolTip when click on seat in mobile
        * @param {Object} seat
        * @param {String} cabinIndex
        * @param {String} rowIndex
        * @param {String} seatIndex
        * @param {Object} event
        */
        function tooltipTouch (seat, cabinIndex, rowIndex, seatIndex, event) {
            if (vm.isAllowed(seat.passengersAllowed)) {
                if (!isDisabledOccupation(seat.occupation)) {
                    $scope.$emit('closeLeyendCollapse');
                    if (vm.isMobile && !vm.tooltipOpened) {
                        buildTooltipTouch(seat, cabinIndex, rowIndex, seatIndex, event);
                        vm.tooltipOpened = true;
                    } else if (vm.isMobile) {
                        if (event.target.closest('.ib-map__column-label')) {
                            vm.tooltipComponent.css('display', 'none');
                            vm.tooltipOpened = false;
                            buildTooltipTouch(seat, cabinIndex, rowIndex, seatIndex, event);
                            vm.tooltipOpened = true;
                        }
                    }
                }
            }
        }


        /**
         * Show tooltip when user  mouseover of seat
         * @param {Object} seat Information of seat
         * @param {Object} event Event
         */
        function tooltipHover (seat, event) {
            if (!vm.isMobile) {
                buildTooltipHover(seat, event);
                vm.tooltipOpened = true;
            }
        }

        /**
         * Check if seat is disable
         * @param {String} occupation State of seat
         */
        function isDisabledOccupation (occupation) {
            return occupation === AncillariesConstants.SEAT_OCCUPATIONS.blocked || occupation === AncillariesConstants.SEAT_OCCUPATIONS.occupied
                || occupation === AncillariesConstants.SEAT_OCCUPATIONS.occupiedOtherUser || occupation === AncillariesConstants.SEAT_OCCUPATIONS.selection;
        }


        /**
           * Open tooltip when user mouseover
           * @param {Object} seat Seat information
           * @param {Object} event Event
           */
        function buildTooltipHover (seat, event) {
            if (angular.element('#toolTipHover').length > 0) {
                angular.element('#toolTipHover').remove();
            }

            const tooltip = angular.element('<div id="toolTipHover" class="ib-map-tooltip ib-map-tooltip--narrow" style="display: block">'
                + ' <div class="ib-map-tooltip__container ib-map-tooltip__container--padding-min">'
                + '  <div class="ib-map-tooltip__wrapper">'
                + '   <span class="ib-map-tooltip__title">' + seat.row + seat.column + ' - ' + seat.seatTypeMessasge + ' - ' + getPricePassenger(seat, vm.currentPassenger.id) + '</span>'
                + '  <span class="ib-map-tooltip__subtitle"></span>'
                + '  <ul class="ib-map-tooltip__list">' + generateTooltipMessage(seat.tooltipMessages) + '</ul>'
                + '</div>'
                + '</div>'
                + ' <div class="ib-map-tooltip__arrow"></div>'
                + '</div>'
            );
            angular.element(event.target).parent().append($compile(tooltip)($scope));
        }



        /**
         * Generate tooltip of seat selected and added to view.
         * @param {Object} seat Seat information
         * @param {Integer} cabinIndex Number of cabin index of seat
         * @param {Integer} rowIndex Number of row
         * @param {Integer} seatIndex Number of seat
         * @param {Object} event Event
         */
        function buildTooltipTouch (seat, cabinIndex, rowIndex, seatIndex, event) {
            if (angular.element('#toolTipTouch').length > 0) {
                angular.element('#toolTipTouch').remove();

            }
            vm.seatInfoSelected = { seat: seat, cabinIndex: cabinIndex, rowIndex: rowIndex, seatIndex: seatIndex };
            const tooltip = angular.element('<div id="toolTipTouch" class="ib-map-tooltip-touch" style="display: block">' +
                '<div class="ib-map-tooltip-touch__container">' +
                '<div class="ib-map-tooltip-touch__header">' +
                '<span class="ib-map-tooltip-touch__icon icon-asiento"></span>' +
                '<div class="ib-map-tooltip-touch__wrapper-title">' +
                '<span class="ib-map-tooltip-touch__title">' + seat.row + seat.column + '</span>' +
                '<span class="ib-map-tooltip-touch__subtitle">' + seat.seatTypeMessasge + '</span>' +
                '</div >' +
                '</div >' +
                '<div class="ib-map-tooltip-touch__body">' +
                '<span class="ib-map-tooltip-touch__title-list"></span>' +
                '<ul class="ib-map-tooltip-touch__list">' + generateTooltipMessage(seat.tooltipMessages) + '</ul>' +
                '<span class="ib-map-tooltip-touch__price">' + $filter('translate')('PRICE_TEXT') + getPricePassenger(seat, vm.currentPassenger.id) + '</span>' +
                '<button type="button" class="ib-button ib-button-medium ib-map-tooltip-touch__button">' + $filter('translate')('SELECT_BUTTON_TEXT') + '</button>' +
                '</div>' +
                '</div>' +
                '<div class="ib-map-tooltip-touch__arrow ib-map-tooltip-touch__arrow--big"></div>' +
                '</div>');

            tooltip.attr('ng-click', 'mapSeats.selectSeatTooltip()');
            angular.element(event.target).parent().append($compile(tooltip)($scope));

            vm.tooltipComponent = tooltip;
            $timeout(() => {
                scrollToTooltip();
            });

            vm.selectSeatTooltip = function () {
                const modalMessage = getModalMessage(vm.seatInfoSelected.seat.modalMessages);
                if (modalMessage !== null) {
                    const modalType = getModalType(modalMessage.type);
                    ModalServiceAncillaries.openFeatureModal(modalType.templateUrl, modalType.blocked, modalMessage.message, modalType.class).result.then(acceptFeature, cancelFeature);
                } else {
                    acceptFeature();
                }

                function acceptFeature () {
                    vm.seatInfoSelected.seat.occupation = 'SELECTION';
                    changeSeat(vm.seatInfoSelected.cabinIndex, vm.seatInfoSelected.rowIndex, vm.seatInfoSelected.seatIndex);
                    angular.element('#toolTipTouch').remove();
                    vm.tooltipOpened = false;
                }

                function cancelFeature () {
                    angular.element('#toolTipTouch').remove();
                    vm.tooltipOpened = false;
                }
            };
        }


        /**
         * Return price for passenger in seat map
         * @param {Object} seat Information passenger seat
         * @param {Integer} idPassenger Id of passenger for get price
         */
        function getPricePassenger (seat, idPassenger) {
            return seat.passengersPriceLabels[idPassenger];
        }


        /**
         * Generate tooltip message
         * @param {Array} tooltipMessages Messages returned by service for show in tooltip
         */
        function generateTooltipMessage (tooltipMessages) {
            let tooltipMessage = '', i;

            if (tooltipMessages.length > 0) {
                for (i = 0; i < tooltipMessages.length; i++) {
                    tooltipMessage += '<li>' + tooltipMessages[i] + '</li>';
                } return tooltipMessage;
            }
        }


        /**
         * Return message of seat returned by service
         * @param {Object} modalMessages
         */
        function getModalMessage (modalMessages) {
            let found = false, i = 0, modalMessage = null;
            while (!found && i < modalMessages.length) {
                if (modalMessages[i].passengers.indexOf('' + vm.currentPassenger.id) !== -1) {
                    found = true;
                    modalMessage = { message: modalMessages[i].message, type: modalMessages[i].type };
                }
                i++;
            }
            return modalMessage;
        }

        /**
         * Return type modal
         * @param {String} modalType
         */
        function getModalType (modalType) {
            let modal = {};
            switch (modalType) {
                    case AncillariesConstants.SeatModalTypes.disclaimer: modal = { templateUrl: 'ib-modal-map-seats-emergency.html', blocked: true, class: 'ib-modals ib-modals--sm' }; break;
                    default: modal = { templateUrl: 'ib-modal-seat-map-warning.html', blocked: false, class: 'ib-modals ib-modals--sm' };
            }
            return modal;
        }
    }
})();
